/* EntityEdit.jsx */
import React, { useState, useEffect, useRef } from 'react';
import './EntityEdit.css';
import API_ENDPOINTS from '../../../config/apiEndpoints';
import {
    PhoneCall, Mail, MessageSquare, Mic,
    FileEdit, Upload, ClipboardCheck,
    Calendar, Percent, Settings, User, Edit2, X, Save, FileText,
    Building, MapPin, Phone, Search, ChevronDown, Plus, MoreHorizontal
} from 'lucide-react';
import Loader from '../../../components/Loader/Loader';
import OperationsForms from './Operations/OperationsForms';

const NEW_ADDED_BASE_URL = (process.env.REACT_APP_BACKEND_BASEURL_FOR_DEVELOPMENT || '').replace(/\/$/, '');
const Get_EntityDeatils = `${NEW_ADDED_BASE_URL}${API_ENDPOINTS.PIPELINE.GET_SCORECARD_DETAILS_NEW}`;
const API_BASE = (process.env.REACT_APP_WCF_API_BASE_URL || '').replace(/\/$/, '');
const center_of_edication = `${API_BASE}${API_ENDPOINTS.FOLLOWUPS.GET_CENTER_OF_EDUCATION_EDIT}`;
const Get_campaign_for_edit = `${API_BASE}${API_ENDPOINTS.FOLLOWUPS.GET_CAMPAIGN_FOR_EDIT}`;
const Get_country = `${API_BASE}${API_ENDPOINTS.INVOICE.GET_COUNTRY}`;
const Get_State = `${API_BASE}${API_ENDPOINTS.INVOICE.GET_STATE_BY_COUNTRY}`;
const Get_city_By_State = `${API_BASE}${API_ENDPOINTS.INVOICE.GET_CITY_BY_STATE}`;
const SaveEdit = `${API_BASE}${API_ENDPOINTS.FOLLOWUPS.EDIT_LEAD_SAVE}`;
const EDIT_CUSTOM_FIELDS = `${(process.env.REACT_APP_SERVICES_API_BASE_URL || '').replace(/\/$/, '')}/UserCRM/GetAllSegmentList`;
const TOKEN = (process.env.REACT_APP_TOKE_UNIVERSAL_TOKEN || '-2295521862261168');

const countryList = [
    { name: "India", dialCode: "+91", flag: "https://flagcdn.com/w320/in.png", code: "IN" }
];

const COUNTRY_MOBILE_VALIDATION = {
    'IN': { minLen: 10, maxLen: 10 }, 'US': { minLen: 10, maxLen: 10 },
    'GB': { minLen: 10, maxLen: 11 }, 'AU': { minLen: 9, maxLen: 9 },
    'CA': { minLen: 10, maxLen: 10 }, 'AE': { minLen: 9, maxLen: 9 },
    'SA': { minLen: 9, maxLen: 9 },  'QA': { minLen: 8, maxLen: 8 },
    'SG': { minLen: 8, maxLen: 8 },  'MY': { minLen: 9, maxLen: 10 },
    'PK': { minLen: 10, maxLen: 10 }, 'BD': { minLen: 10, maxLen: 10 },
    'NP': { minLen: 10, maxLen: 10 }, 'LK': { minLen: 9, maxLen: 9 },
    'KW': { minLen: 8, maxLen: 8 },  'BH': { minLen: 8, maxLen: 8 },
    'OM': { minLen: 8, maxLen: 8 },  'JO': { minLen: 9, maxLen: 9 },
    'DE': { minLen: 10, maxLen: 11 }, 'FR': { minLen: 9, maxLen: 9 },
    'RU': { minLen: 10, maxLen: 10 }, 'CN': { minLen: 11, maxLen: 11 },
    'JP': { minLen: 10, maxLen: 11 }, 'ZA': { minLen: 9, maxLen: 9 },
    'NG': { minLen: 10, maxLen: 10 }, 'BR': { minLen: 10, maxLen: 11 },
    'MX': { minLen: 10, maxLen: 10 }, 'PH': { minLen: 10, maxLen: 10 },
};

const cleanMobileForSave = (rawMobile, dialCode) => {
    if (!rawMobile) return '';
    let num = String(rawMobile).replace(/\s+/g, '');
    const code = String(dialCode || '').replace(/[+\s]/g, '');
    if (num.startsWith('+')) num = num.slice(1);
    if (code && num.startsWith(code)) num = num.slice(code.length);
    return num;
};

const validateMobileNum = (rawMobile, countryCode) => {
    if (!rawMobile) return null;
    const digits = String(rawMobile).replace(/\D/g, '');
    const rules = COUNTRY_MOBILE_VALIDATION[countryCode];
    if (!rules) return null;
    if (digits.length < rules.minLen || digits.length > rules.maxLen)
        return `Must be ${rules.minLen === rules.maxLen ? rules.minLen : rules.minLen + '-' + rules.maxLen} digits`;
    return null;
};

export const EntityEdit = ({ editingEntity, onCloseEntity }) => {
    const [editEntityData, setEditEntityData] = useState({});
    const [isEditEntityLoading, setIsEditEntityLoading] = useState(false);
    const [saveMessage, setSaveMessage] = useState({ type: '', text: '' });
    const [currentOperationMode, setCurrentOperationMode] = useState('none');
    const [showSettingsMenu, setShowSettingsMenu] = useState(false);

    // Multi-Mobile & Country Code State
    const [countryList, setCountryList] = useState([
        { name: "India", dialCode: "+91", flag: "https://flagcdn.com/w320/in.png", code: "IN" }
    ]);
    const [mobileFields, setMobileFields] = useState(['Mobile']);
    const [mobileErrors, setMobileErrors] = useState({ Mobile: null, MobileNo1: null, MobileNo2: null });
    const [selectedCountries, setSelectedCountries] = useState({
        Mobile: { name: "India", dialCode: "+91", flag: "https://flagcdn.com/w320/in.png", code: "IN" },
        MobileNo1: { name: "India", dialCode: "+91", flag: "https://flagcdn.com/w320/in.png", code: "IN" },
        MobileNo2: { name: "India", dialCode: "+91", flag: "https://flagcdn.com/w320/in.png", code: "IN" }
    });
    const [activeCountryDropdown, setActiveCountryDropdown] = useState(null);
    const [countrySearch, setCountrySearch] = useState('');
    const countryDropdownRef = useRef(null);
    const fileInputRef = useRef(null);

    const [emailFields, setEmailFields] = useState(['Email']);
    const [tagInput, setTagInput] = useState('');

    // Dropdown States
    const [countries, setCountries] = useState([]);
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);
    const [sources, setSources] = useState([]);
    const [mediums, setMediums] = useState([]);
    const [campaigns, setCampaigns] = useState([]);
    const [courseOptions, setCourseOptions] = useState([]);
    const [centerOptions, setCenterOptions] = useState([]);
    const [isStatesLoading, setIsStatesLoading] = useState(false);
    const [isCitiesLoading, setIsCitiesLoading] = useState(false);

    // Tags & Suggestions
    const [leadSearchSuggestions, setLeadSearchSuggestions] = useState([]);
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [isSearchingLeads, setIsSearchingLeads] = useState(false);
    const [tagInputValue, setTagInputValue] = useState("");

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (countryDropdownRef.current && !countryDropdownRef.current.contains(event.target)) {
                setActiveCountryDropdown(null);
                setCountrySearch('');
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    useEffect(() => {
        const init = async () => {
            if (editingEntity) {
                const freshCountries = await fetchDynamicCountries();
                fetchEntityDetails(freshCountries);
                fetchSourceMediumCampaign('SourceName', setSources);
                fetchSourceMediumCampaign('MediumName', setMediums);
                fetchSourceMediumCampaign('CampaignName', setCampaigns);
                fetchCourseAndCenterOptions();
                fetchCountries();
            } else {
                setEditEntityData({});
            }
        };
        init();
    }, [editingEntity]);

    const fetchDynamicCountries = async () => {
        try {
            const response = await fetch('https://raw.githubusercontent.com/mledoze/countries/master/countries.json');
            const data = await response.json();
            const processed = data.map(c => ({
                name: c.name.common,
                dialCode: (c.idd?.root || '') + (c.idd?.suffixes ? c.idd.suffixes[0] : ""),
                flag: c.flags?.png || `https://flagcdn.com/w320/${(c.cca2 || '').toLowerCase()}.png`,
                code: c.cca2
            })).filter(c => c.dialCode).sort((a, b) => a.name.localeCompare(b.name));
            setCountryList(processed);
            return processed;
        } catch (error) {
            console.error("Error fetching dynamic countries:", error);
            return countryList;
        }
    };

    const parseTelephone = (tel, list = countryList) => {
        if (!tel) return { dialCode: "+91", number: "" };
        const cleanTel = tel.replace(/\s+/g, '');
        const sortedList = [...list].sort((a, b) => b.dialCode.length - a.dialCode.length);
        for (const c of sortedList) {
            if (cleanTel.startsWith(c.dialCode.replace('+', '')) || cleanTel.startsWith(c.dialCode)) {
                return { dialCode: c.dialCode, number: cleanTel.replace(c.dialCode, '').replace(c.dialCode.replace('+', ''), '') };
            }
        }
        return { dialCode: "+91", number: cleanTel };
    };

    const handleAddTag = (e) => {
        if (e.key === 'Enter' && tagInput.trim()) {
            e.preventDefault();
            const currentTags = editEntityData.Tags ? editEntityData.Tags.split(',').map(t => t.trim()).filter(Boolean) : [];
            const newTag = tagInput.trim();
            if (!currentTags.includes(newTag)) {
                const updatedTags = [...currentTags, newTag].join(',');
                setEditEntityData({ ...editEntityData, Tags: updatedTags });
            }
            setTagInput('');
        }
    };

    const handleRemoveTag = (tagToRemove) => {
        const currentTags = editEntityData.Tags ? editEntityData.Tags.split(',').map(t => t.trim()).filter(Boolean) : [];
        const updatedTags = currentTags.filter(t => t !== tagToRemove).join(',');
        setEditEntityData({ ...editEntityData, Tags: updatedTags });
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setEditEntityData({ ...editEntityData, ProfileImgFileName: reader.result });
            };
            reader.readAsDataURL(file);
        }
    };

    const fetchCountries = async () => {
        try {
            const response = await fetch(Get_country, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({}) });
            const data = await response.json();
            const raw = data?.Details || data?.d || data?.Data || data?.data || data;
            const list = typeof raw === 'string' ? JSON.parse(raw) : (raw || []);
            setCountries(Array.isArray(list) ? list : []);
        } catch (error) { console.error("Error fetching countries:", error); }
    };

    const fetchStates = async (countryId) => {
        if (!countryId) return; setIsStatesLoading(true);
        try {
            const response = await fetch(Get_State, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ CountryId: countryId.toString() }) });
            const data = await response.json();
            const raw = data?.Details || data?.d || data?.Data || data?.data || data;
            const list = typeof raw === 'string' ? JSON.parse(raw) : (raw || []);
            setStates(Array.isArray(list) ? list : []);
            setCities([]);
        } catch (error) { console.error("Error fetching states:", error); } finally { setIsStatesLoading(false); }
    };

    const fetchCities = async (stateId) => {
        if (!stateId) return; setIsCitiesLoading(true);
        try {
            const response = await fetch(Get_city_By_State, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ StateId: stateId.toString() }) });
            const data = await response.json();
            const raw = data?.Details || data?.d || data?.Data || data?.data || data;
            const list = typeof raw === 'string' ? JSON.parse(raw) : (raw || []);
            setCities(Array.isArray(list) ? list : []);
        } catch (error) { console.error("Error fetching cities:", error); } finally { setIsCitiesLoading(false); }
    };

    const fetchSourceMediumCampaign = async (type, setter) => {
        try {
            const response = await fetch(Get_campaign_for_edit, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ UserId: localStorage.getItem('userId') || "34594", type: type }) });
            const data = await response.json();
            const raw = data?.Details || data?.d || data?.Data || data?.data || data;
            const list = typeof raw === 'string' ? JSON.parse(raw) : (raw || []);
            setter(Array.isArray(list) ? list : []);
        } catch (error) { console.error(`Error fetching ${type}:`, error); }
    };

    const fetchCourseAndCenterOptions = async () => {
        try {
            const response = await fetch(center_of_edication, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ CustomFieldIds: 5292, ParentId: "34594" }) });
            const data = await response.json();
            const raw = data?.d || data?.Details || data?.Data || data;
            const list = typeof raw === 'string' ? JSON.parse(raw) : raw;
            const item = Array.isArray(list) ? list[0] : list;
            if (item?.Choices) setCourseOptions(item.Choices.split(',').map(s => s.trim()).filter(Boolean));
            if (item?.CenterChoices) setCenterOptions(item.CenterChoices.split(',').map(s => s.trim()).filter(Boolean));
            else if (item?.Choices) setCenterOptions(item.Choices.split(',').map(s => s.trim()).filter(Boolean));
        } catch (error) { console.error("Error fetching course/center options:", error); }
    };

    const fetchEntityDetails = async (freshCountryList = countryList) => {
        if (!editingEntity) return;
        setIsEditEntityLoading(true);
        try {
            const entityLeadId = editingEntity.LeadId || editingEntity.enquiryId || editingEntity.leadId || editingEntity.id;
            const payload = { Token: TOKEN, Details: { LeadId: parseInt(entityLeadId, 10), ParentId: localStorage.getItem('userId') || '34594' } };
            const response = await fetch(Get_EntityDeatils, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) });
            const data = await response.json();
            
            let mappedData = {};
            if (data?.Details) {
                const inner = typeof data.Details === 'string' ? JSON.parse(data.Details) : data.Details;
                let raw = Array.isArray(inner) ? inner[0] : (inner || {});

                // Mapping logic
                mappedData = {
                    ...raw,
                    LeadId: raw.leadid || raw.LeadId || raw.LeadID || '',
                    LeadNo: raw.leadno || raw.leadnumber || raw.LeadNo || raw.LeadNumber || raw.leadNo || '',
                    Name: raw.personname || raw.Name || '',
                    Company: raw.companyname || raw.Company || '',
                    Mobile: raw.mobileno || raw.Mobile || raw.phones || '',
                    MobileNo1: raw.MobileNo1 || raw.mobileno1 || '',
                    MobileNo2: raw.MobileNo2 || raw.mobileno2 || '',
                    Email: raw.emailid || raw.Email || raw.emails || '',
                    EmailID1: raw.EmailID1 || raw.emailid1 || '',
                    EmailID2: raw.EmailID2 || raw.emailid2 || '',
                    Source: raw.sourceid || raw.SourceName || raw.Source || '',
                    Medium: raw.mediumid || raw.MediumName || raw.Medium || '',
                    Campaign: raw.campaignid || raw.CampaignName || raw.Campaign || '',
                    Tags: raw.groups || raw.LeadTags || raw.Tags || '',
                    cityid: raw.cityid || raw.city || '',
                    stateid: raw.stateid || raw.state || '',
                    countryid: raw.countryid || raw.country || '',
                    ResidentialAddress: raw.residentialaddress || raw.Address || '',
                    OfficialAddress: raw.officeaddress || raw.official_address || '',
                    Remarks: raw.remark || raw.Remarks || ''
                };

                // Profile Image Mapping
                const profileImg = raw.ProfileImgFileName || raw.profileimgfilename || raw.ImageUrl || raw.imageurl || raw.ProfileImg || raw.profileimg || "";
                mappedData.ProfileImgFileName = profileImg;

                // Sync dynamic mobile fields
                const mFields = ['Mobile'];
                const sCountries = { ...selectedCountries };

                const pm = parseTelephone(mappedData.Mobile, freshCountryList);
                mappedData.Mobile = pm.number;
                sCountries.Mobile = freshCountryList.find(c => c.dialCode === pm.dialCode) || freshCountryList.find(c => c.code === 'IN') || freshCountryList[0];

                if (mappedData.MobileNo1) {
                    mFields.push('MobileNo1');
                    const pm1 = parseTelephone(mappedData.MobileNo1, freshCountryList);
                    mappedData.MobileNo1 = pm1.number;
                    sCountries.MobileNo1 = freshCountryList.find(c => c.dialCode === pm1.dialCode) || freshCountryList.find(c => c.code === 'IN') || freshCountryList[0];
                }
                if (mappedData.MobileNo2) {
                    mFields.push('MobileNo2');
                    const pm2 = parseTelephone(mappedData.MobileNo2, freshCountryList);
                    mappedData.MobileNo2 = pm2.number;
                    sCountries.MobileNo2 = freshCountryList.find(c => c.dialCode === pm2.dialCode) || freshCountryList.find(c => c.code === 'IN') || freshCountryList[0];
                }

                // Sync email fields
                const eFields = ['Email'];
                if (mappedData.EmailID1) eFields.push('EmailID1');
                if (mappedData.EmailID2) eFields.push('EmailID2');

                setMobileFields(mFields);
                setSelectedCountries(sCountries);
                setEmailFields(eFields);
                setEditEntityData(mappedData);

                // Fetch states/cities based on loaded data
                if (mappedData.countryid) fetchStates(mappedData.countryid);
                if (mappedData.stateid) fetchCities(mappedData.stateid);
            }
        } catch (error) { console.error("Error fetching entity details:", error); } finally { setIsEditEntityLoading(false); }
    };

    const handleLeadSearch = async (value) => {
        setTagInputValue(value);
        if (!value || value.trim().length < 2) {
            setLeadSearchSuggestions([]);
            setShowSuggestions(false);
            return;
        }
        try {
            setIsSearchingLeads(true);
            const response = await fetch(EDIT_CUSTOM_FIELDS, {
                method: 'POST',
                headers: { "Content-Type": "application/json; charset=utf-8" },
                body: JSON.stringify({ Token: "-2295521862261168", Details: { strFilter: value } })
            });
            if (response.ok) {
                const result = await response.json();
                const data = typeof result.d === 'string' ? JSON.parse(result.d) : result.d;
                setLeadSearchSuggestions(Array.isArray(data) ? data : []);
                setShowSuggestions(true);
            }
        } catch (error) { console.error("Error searching leads:", error); } finally { setIsSearchingLeads(false); }
    };

    const handleSelectSuggestion = (lead) => {
        const selectedName = lead.PersonName || lead.Name || lead.name;
        // Append selected name as a tag, do not overwrite other fields
        const existingTags = editEntityData.Tags ? editEntityData.Tags.split(',').map(t => t.trim()).filter(Boolean) : [];
        if (selectedName && !existingTags.includes(selectedName)) {
            existingTags.push(selectedName);
        }
        setEditEntityData(prev => ({ ...prev, Tags: existingTags.join(', ') }));
        setTagInputValue("");
        setShowSuggestions(false);
    };

    const handleSave = async () => {
        try {
            setIsEditEntityLoading(true);
            const rootUserId = localStorage.getItem('userId') || "34594";
            const rootParentId = "34594";
            const d = editEntityData;

            // Resolve LeadId as string - keep as string to avoid NaN from parseInt
            const leadId = (d.LeadId || d.leadid || d.LeadID ||
                editingEntity?.LeadId || editingEntity?.leadId || editingEntity?.leadid ||
                editingEntity?.enquiryId || editingEntity?.id || "").toString();

            // Precompute tomorrow date for FollowupDate
            const tomorrowDate = new Date();
            tomorrowDate.setDate(tomorrowDate.getDate() + 1);
            const tomorrowStr = tomorrowDate.toISOString().split('T')[0];

            console.log("=== Followup EntityEdit Save ===", { leadId, editingEntity });

            // Custom Field Mapping
            const customFieldMap = {
                "amount": "8844", "Service": "8845", "Charges": "8846", "Bank_Name_okl": "8847",
                "Bill_Amount": "8848", "Due_Date": "8849", "Card_Status": "8850", "Card_Type": "8851",
                "Bank_Name_okl_2": "8868", "Bill_Amount_2": "8869", "Due_Date_2": "8870", "Card_Status_2": "8871",
                "Card_Type_2": "8872", "Bank_Name_okl_3": "8873", "Bill_Amount_3": "8874", "Due_Date_3": "8875",
                "Card_Status_3": "8876", "Card_Type_3": "8877", "ClientID": "2686", "DOB": "1237",
                "NAME": "2503", "StudyLevel": "5291", "Course": "5292", "Centre_For_Education": "5293",
                "whatsaap_response": "2796", "Response": "2795", "User_Code": "6276",
                "Company_Incorporation_Date": "7580", "MCA_Registered_City": "7581", "Equity_Percentage": "7583",
                "Mandate_Start_Date": "7585", "Mandate_End_Date": "7586", "OPE_Preapproval": "7587",
                "Business_Referral_Mandate": "7588", "Addendum": "7589", "Project_Name": "7620",
                "is_Adult": "7692", "Locate_Our_Office": "8153", "test121": "8167",
                "number_of_users": "8244", "rrtr": "8580", "dytdutdtjg": "8629",
                "pending_amount": "8630", "warranty_valid_till": "8780", "warranty_start_date": "8781",
                "product": "8066", "Select_Option": "8899", "DATE_TIME": "8903",
                "monthly_EMI": "8994", "Demo_date": "9513", "new_test": "10056",
                "trest": "10365", "testing09099": "10528", "upload_doc": "10545",
                "official_address": "8142", "test": "8171", "KW_Requirement": "10620",
                "gender": "10546"
            };

            const formatDateForAPI = (dateString, useHyphen = true) => {
                if (!dateString) return "";
                try {
                    const date = new Date(dateString);
                    if (isNaN(date.getTime())) return dateString;
                    const format = date.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
                    return useHyphen ? format.replace(/ /g, '-') : format;
                } catch (e) { return ""; }
            };

            const lstCustomField = Object.entries(customFieldMap).map(([key, id]) => {
                let value = d[key]?.toString() || "";
                if (id === "8849" && !value) value = "01 Jan 1900";
                if (id === "1237" && !value) value = "28-Aug-2023";
                if (id === "2686" && !value) value = "0";
                if (id === "2503" && !value) value = "0";
                if (id === "5291" && !value) value = "Diploma";
                if (id === "5292" && !value) value = "Diploma in Computers";
                if (id === "5293" && !value) value = "Delhi";
                if (id === "2796" && !value) value = "0";
                if (id === "2795" && !value) value = "0";
                if (id === "6276" && !value) value = "0";
                if (id === "7620" && !value) value = "1";
                if (id === "7692" && !value) value = "yes";
                if (id === "8167" && !value) value = "11";
                if (id === "8629" && !value) value = "28-Jan-2030";
                if (id === "8630" && !value) value = "01-Feb-1938";
                if (id === "8066" && !value) value = "01-Dec-1903";
                if (id === "8903" && !value) value = "28-Feb-2026";
                if (id === "10528" && !value) value = "1";
                if (id === "10546" && !value) value = "Male";
                if (id === "8849" && value && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
                    value = formatDateForAPI(value, false);
                }
                return { FieldId: id, FieldValue: value };
            });

            // Validate mobile numbers before saving
            const mobileValidationErrors = {};
            mobileFields.forEach(fk => {
                const ctr = selectedCountries[fk];
                const err = validateMobileNum(d[fk], ctr?.code);
                if (err) mobileValidationErrors[fk] = err;
            });
            if (Object.keys(mobileValidationErrors).length > 0) {
                setMobileErrors(mobileValidationErrors);
                setSaveMessage({ type: 'error', text: 'Please fix mobile number errors before saving.' });
                setTimeout(() => setSaveMessage({ type: '', text: '' }), 3000);
                setIsEditEntityLoading(false);
                return;
            }
            setMobileErrors({});

            const buildMobile = (fieldKey) => {
                const mob = d[fieldKey] || '';
                if (!mob) return '';
                const ctr = selectedCountries[fieldKey];
                const dc = String(ctr?.dialCode || '+91').replace('+', '');
                const cleaned = cleanMobileForSave(mob, dc);
                return dc + cleaned;
            };

            const objLead_BO = {
                LeadId: leadId,
                LeadNo: d.LeadNo?.toString() || "",
                PersonName: d.Name || d.personname || "",
                CompanyName: d.Company || d.companyname || "",
                MobileNo: buildMobile('Mobile'),
                MobileNo1: mobileFields.includes('MobileNo1') ? buildMobile('MobileNo1') : "",
                MobileNo2: mobileFields.includes('MobileNo2') ? buildMobile('MobileNo2') : "",
                EmailID: d.Email || d.emailid || "",
                EmailID1: emailFields.includes('EmailID1') ? (d.EmailID1 || "") : "",
                EmailID2: emailFields.includes('EmailID2') ? (d.EmailID2 || "") : "",
                City: d.cityid || "",
                State: d.stateid || "",
                Country: d.countryid || "",
                PinCode: d.pincode?.toString() || "0",
                SourceName: (() => {
                    const v = d.Source?.toString() || "";
                    if (!v) return "0";
                    if (/^\d+$/.test(v)) return v;
                    const found = sources.find(x => (x.SrcmedCampName || x.Name || x.name || x.Text || '') === v);
                    return (found?.SrcmedCampID || found?.Id || found?.id || found?.ID || "0").toString();
                })(),
                MediumName: (() => {
                    const v = d.Medium?.toString() || "";
                    if (!v) return "0";
                    if (/^\d+$/.test(v)) return v;
                    const found = mediums.find(x => (x.SrcmedCampName || x.Name || x.name || x.Text || '') === v);
                    return (found?.SrcmedCampID || found?.Id || found?.id || found?.ID || "0").toString();
                })(),
                CampaignName: (() => {
                    const v = d.Campaign?.toString() || "";
                    if (!v) return "0";
                    if (/^\d+$/.test(v)) return v;
                    const found = campaigns.find(x => (x.SrcmedCampName || x.Name || x.name || x.Text || '') === v);
                    return (found?.SrcmedCampID || found?.Id || found?.id || found?.ID || "0").toString();
                })(),
                ResidentialAddress: d.residentialaddress || d.ResidentialAddress || "",
                OfficialAddress: d.officialaddress || d.officeaddress || d.OfficialAddress || "",
                CountryCode: selectedCountries.Mobile?.code || "IN",
                CountryCode1: selectedCountries.MobileNo1?.code || "IN",
                CountryCode2: selectedCountries.MobileNo2?.code || "IN",
                AssignedTo: parseInt(rootUserId, 10),
                ParentID: parseInt(rootParentId, 10),
                FollowUpStatus: 1,
                FollowupDate: tomorrowStr,
                NextStatusDate: tomorrowStr,
                CreatedBy: parseInt(rootUserId, 10),
                ModifiedBy: parseInt(rootUserId, 10),
                InitialRemarks: d.Remarks || "",
                Remarks: d.Remarks || "",
                LeadTags: d.Tags || "",
                ProfileImgFileName: d.ProfileImgFileName || "",
                lstCustomField
            };

            const payload = { objLead_BO, ParentId: rootParentId, UserId: rootUserId };
            console.log("Followup EntityEdit Save Payload:", JSON.stringify(payload, null, 2));
            const response = await fetch(SaveEdit, { method: 'POST', headers: { "Content-Type": "application/json; charset=utf-8" }, body: JSON.stringify(payload) });
            if (response.ok) {
                const result = await response.json();
                console.log("Save result:", result);
                setSaveMessage({ type: 'success', text: 'Lead details updated successfully!' });
                setTimeout(() => onCloseEntity(), 2000);
            } else {
                setSaveMessage({ type: 'error', text: `Failed to save. Status: ${response.status}` });
                setTimeout(() => setSaveMessage({ type: '', text: '' }), 3000);
            }
        } catch (error) {
            console.error("Error saving entity:", error);
            setSaveMessage({ type: 'error', text: 'An error occurred while saving.' });
            setTimeout(() => setSaveMessage({ type: '', text: '' }), 3000);
        } finally { setIsEditEntityLoading(false); }
    };

    if (!editingEntity) return null;

    const renderField = (label, key, type = "text", options = null) => (
        <div className="entity-field-group">
            <label>{label}</label>
            {options ? (
                <select className="entity-select" value={editEntityData[key] || ''} onChange={e => {
                    setEditEntityData({ ...editEntityData, [key]: e.target.value });
                    if (key === 'countryid') fetchStates(e.target.value);
                    if (key === 'stateid') fetchCities(e.target.value);
                }}>
                    <option value="">Select {label}</option>
                    {options.map((opt, idx) => {
                        const val = typeof opt === 'object' ? (opt.Id || opt.ID || opt.id || opt.SrcmedCampID || '') : opt;
                        const text = typeof opt === 'object' ? (opt.Text || opt.name || opt.Name || opt.SrcmedCampName || opt.Value || JSON.stringify(opt)) : opt;
                        return (
                            <option key={idx} value={val}>{text}</option>
                        );
                    })}
                </select>
            ) : key === 'Tags' ? (
                <div className="entity-tags-wrapper">
                    <div className="tags-pill-container" style={{
                        display: 'flex', flexWrap: 'wrap', gap: '6px', padding: '6px',
                        border: '1px solid #ddd', borderRadius: '4px', backgroundColor: '#fff', minHeight: '38px'
                    }}>
                        {(editEntityData.Tags || '').split(',').map((tag, idx) => tag.trim() ? (
                            <span key={idx} className="tag-pill" style={{
                                backgroundColor: '#eaf4e6', color: '#6ab04c', padding: '3px 8px',
                                borderRadius: '14px', fontSize: '13px', display: 'flex', alignItems: 'center', gap: '5px'
                            }}>
                                {tag.trim()}
                                <X size={12} style={{ cursor: 'pointer', color: '#6ab04c' }}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        const newTags = (editEntityData.Tags || '').split(',').map(t => t.trim()).filter(Boolean);
                                        newTags.splice(idx, 1);
                                        setEditEntityData({ ...editEntityData, Tags: newTags.join(', ') });
                                    }}
                                />
                            </span>
                        ) : null)}
                        <div style={{ position: 'relative', flexGrow: 1, minWidth: '150px' }}>
                            <input
                                type="text"
                                value={tagInputValue}
                                placeholder="Search tags"
                                style={{ border: 'none', outline: 'none', width: '100%', padding: '4px 0', fontSize: '13px', backgroundColor: 'transparent' }}
                                onChange={e => handleLeadSearch(e.target.value)}
                                onKeyDown={e => {
                                    if (e.key === 'Enter' || e.key === ',' || e.key === 'Tab') {
                                        e.preventDefault();
                                        const val = tagInputValue.trim();
                                        if (val) {
                                            const existing = (editEntityData.Tags || '').split(',').map(t => t.trim()).filter(Boolean);
                                            // Handle multiple comma separated pasted values if needed
                                            const newValues = val.split(',').map(v => v.trim()).filter(Boolean);
                                            const combined = [...existing];
                                            newValues.forEach(nv => {
                                                if (!combined.includes(nv)) combined.push(nv);
                                            });
                                            setEditEntityData({ ...editEntityData, Tags: combined.join(', ') });
                                            setTagInputValue("");
                                            setShowSuggestions(false);
                                        }
                                    }
                                }}
                                onBlur={() => setTimeout(() => setShowSuggestions(false), 200)}
                            />
                            {isSearchingLeads && <div className="search-loader-mini" style={{ right: 0, top: '4px' }}></div>}
                            {showSuggestions && leadSearchSuggestions.length > 0 && (
                                <div className="suggestions-dropdown-entity" style={{ top: '100%', width: '100%' }}>
                                    {leadSearchSuggestions.map((lead, idx) => (
                                        <div key={idx} className="suggestion-item-entity" onClick={() => handleSelectSuggestion(lead)}>
                                            <div className="suggestion-info">
                                                <span className="suggestion-name">{lead.PersonName || lead.Name}</span>
                                                <span className="suggestion-detail">{lead.MobileNo || lead.EmailID}</span>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                    <small style={{
                        display: 'block', marginTop: '6px', fontSize: '11px', color: '#6ab04c',
                        backgroundColor: '#eaf4e6', padding: '6px 10px', borderRadius: '4px', lineHeight: '1.4'
                    }}>
                        Please press comma, tab, or enter key for generating the tag name, or you can also generate a tag by copy and paste with comma separated value.
                    </small>
                </div>
            ) : (
                <div className="entity-input-wrapper" style={{ position: 'relative' }}>
                    <input type={type} className="entity-input" value={editEntityData[key] || ''} onChange={e => {
                        setEditEntityData({ ...editEntityData, [key]: e.target.value });
                    }} />
                </div>
            )}
        </div>
    );

    return (
        <div className="entity-edit-overlay" onClick={onCloseEntity}>
            <div className="entity-edit-panel" onClick={e => e.stopPropagation()}>
                <div className="entity-edit-header">
                    <div className="entity-header-left">
                        <button className="entity-settings-trigger" onClick={(e) => { e.stopPropagation(); setShowSettingsMenu(!showSettingsMenu); }} title="Operations"><Settings size={18} /></button>
                        {showSettingsMenu && (
                            <div className="entity-header-dropdown">
                                {[
                                    { label: 'Add Followup', mode: 'followup', icon: PhoneCall },
                                    { label: 'Send Mail', mode: 'mail', icon: Mail },
                                    { label: 'Send SMS', mode: 'sms', icon: MessageSquare },
                                    { label: 'Send Voice', mode: 'voice', icon: Mic },
                                    { label: 'Upload Document', mode: 'upload', icon: Upload },
                                    { label: 'Add Task', mode: 'task', icon: ClipboardCheck },
                                    { label: 'Add Appointment', mode: 'appointment', icon: Calendar },
                                    { label: 'Add Deal', mode: 'deal', icon: Percent },
                                    { label: 'Add Notes', mode: 'notes', icon: FileEdit },
                                    { label: 'Fill Webform', mode: 'fill-webform', icon: FileText }
                                ].map(item => (
                                    <button key={item.mode} className={`entity-dropdown-item ${currentOperationMode === item.mode ? 'active' : ''}`}
                                        onClick={() => { setCurrentOperationMode(item.mode); setShowSettingsMenu(false); }}>
                                        <item.icon size={14} className="dropdown-icon" /> <span>{item.label}</span>
                                    </button>
                                ))}
                            </div>
                        )}
                        <h3>Edit Entity</h3>
                    </div>
                    <div className="entity-header-actions">
                        <button className="entity-save-btn" onClick={handleSave} disabled={isEditEntityLoading}>{isEditEntityLoading ? 'Saving...' : 'Save Changes'}</button>
                        <button className="entity-edit-close" onClick={onCloseEntity}><X size={20} /></button>
                    </div>
                </div>

                {saveMessage.text && (
                    <div style={{ padding: '8px 15px', margin: '5px 15px', borderRadius: '4px', backgroundColor: saveMessage.type === 'success' ? '#d4edda' : '#f8d7da', color: saveMessage.type === 'success' ? '#155724' : '#721c24', fontSize: '13px', position: 'absolute', top: '70px', left: '20px', right: '80px', zIndex: 1001 }}>
                        {saveMessage.text}
                    </div>
                )}

                <div className="entity-edit-main-container">
                    <div className="entity-edit-content">
                        <div className="entity-edit-body">
                            {isEditEntityLoading && !editEntityData.Name ? <div style={{ padding: '50px', textAlign: 'center' }}><Loader /></div> : (
                                <>
                                    <div className="entity-section">
                                        <div className="entity-section-title">Basic Details</div>
                                        <div className="entity-basic-row">
                                            <div className="entity-avatar-box">
                                                <div className="entity-avatar-inner">
                                                    {editEntityData.ProfileImgFileName ? (
                                                        <img src={editEntityData.ProfileImgFileName} alt="Avatar" className="large-avatar-img" />
                                                    ) : (
                                                        <div className="large-avatar-circle">{(editEntityData.Name || editEntityData.Mobile || '?').charAt(0).toUpperCase()}</div>
                                                    )}
                                                    <div className="entity-avatar-edit-trigger" onClick={() => fileInputRef.current.click()}><Edit2 size={12} /></div>
                                                    <input 
                                                        type="file" 
                                                        ref={fileInputRef} 
                                                        style={{ display: 'none' }} 
                                                        accept="image/*" 
                                                        onChange={handleFileChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="entity-basic-fields">
                                                <div className="entity-grid-2">
                                                    {renderField("Name *", "Name")}
                                                    {renderField("Company", "Company")}
                                                </div>
                                                {/* Multi-Mobile Dynamic Fields */}
                                                <div className="entity-grid-2">
                                                    <div className="entity-mobile-container">
                                                        {mobileFields.map((fieldKey, idx) => (
                                                            <div key={fieldKey} className="entity-field-group">
                                                                <label>{idx === 0 ? "Mobile" : `Mobile ${idx}`}</label>
                                                                <div className="entity-mobile-input-group">
                                                                    <div className="entity-country-selector" onClick={() => {
                                                                        setActiveCountryDropdown(fieldKey);
                                                                        setCountrySearch('');
                                                                    }}>
                                                                        <img src={selectedCountries[fieldKey]?.flag} alt="flag" className="entity-flag-image" />
                                                                        <span className="entity-dial-code">{selectedCountries[fieldKey]?.dialCode}</span>
                                                                        <ChevronDown size={14} />
                                                                    </div>
                                                                    <input
                                                                        type="text"
                                                                        className={`entity-input${mobileErrors[fieldKey] ? ' input-error' : ''}`}
                                                                        value={editEntityData[fieldKey] || ''}
                                                                        onChange={e => {
                                                                            const val = e.target.value.replace(/\s+/g, '');
                                                                            setEditEntityData({ ...editEntityData, [fieldKey]: val });
                                                                            const err = validateMobileNum(val, selectedCountries[fieldKey]?.code);
                                                                            setMobileErrors(prev => ({ ...prev, [fieldKey]: err }));
                                                                        }}
                                                                        placeholder="Enter Mobile"
                                                                    />
                                                                    {idx === 0 ? (
                                                                        mobileFields.length < 3 && (
                                                                            <button className="entity-add-field-btn" onClick={() => setMobileFields([...mobileFields, `MobileNo${mobileFields.length}`])}>
                                                                                <Plus size={16} />
                                                                            </button>
                                                                        )
                                                                    ) : (
                                                                        <button className="entity-remove-field-btn" onClick={() => setMobileFields(mobileFields.filter(f => f !== fieldKey))}>
                                                                            <Plus size={16} style={{ transform: 'rotate(45deg)' }} />
                                                                        </button>
                                                                    )}

                                                                    {activeCountryDropdown === fieldKey && (
                                                                        <div className="entity-country-dropdown" ref={countryDropdownRef}>
                                                                            <div className="country-search-box">
                                                                                <Search size={14} />
                                                                                <input 
                                                                                    type="text" 
                                                                                    placeholder="Search country..." 
                                                                                    value={countrySearch}
                                                                                    onChange={(e) => setCountrySearch(e.target.value)}
                                                                                    onClick={e => e.stopPropagation()} 
                                                                                />
                                                                            </div>
                                                                            <div className="country-options-list">
                                                                                {countryList
                                                                                    .filter(c => 
                                                                                        c.name.toLowerCase().includes(countrySearch.toLowerCase()) || 
                                                                                        c.dialCode.includes(countrySearch)
                                                                                    )
                                                                                    .map((c, i) => (
                                                                                        <div key={i} className="country-option" onClick={(e) => {
                                                                                            e.stopPropagation();
                                                                                            setSelectedCountries({ ...selectedCountries, [fieldKey]: c });
                                                                                            setActiveCountryDropdown(null);
                                                                                            setCountrySearch('');
                                                                                        }}>
                                                                                        <img src={c.flag} alt="" className="option-flag-image" />
                                                                                        <span className="option-country-name">{c.name}</span>
                                                                                        <span className="option-dial-code">{c.dialCode}</span>
                                                                                    </div>
                                                                                ))}
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>

                                                    <div className="entity-email-container">
                                                        {emailFields.map((fieldKey, idx) => (
                                                            <div key={fieldKey} className="entity-field-group">
                                                                <label>{idx === 0 ? "Email" : `Email ${idx}`}</label>
                                                                <div className="entity-mobile-input-group">
                                                                    <input
                                                                        type="text"
                                                                        className="entity-input"
                                                                        value={editEntityData[fieldKey === 'Email' ? 'Email' : fieldKey] || ''}
                                                                        onChange={e => setEditEntityData({ ...editEntityData, [fieldKey === 'Email' ? 'Email' : fieldKey]: e.target.value })}
                                                                        placeholder="Enter Email"
                                                                    />
                                                                    {idx === 0 ? (
                                                                        emailFields.length < 3 && (
                                                                            <button className="entity-add-field-btn" onClick={() => setEmailFields([...emailFields, `EmailID${emailFields.length}`])}>
                                                                                <Plus size={16} />
                                                                            </button>
                                                                        )
                                                                    ) : (
                                                                        <button className="entity-remove-field-btn" onClick={() => setEmailFields(emailFields.filter(f => f !== fieldKey))}>
                                                                            <Plus size={16} style={{ transform: 'rotate(45deg)' }} />
                                                                        </button>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="entity-section">
                                        <div className="entity-grid-3">
                                            <div className="entity-field-group">
                                                <label>Country</label>
                                                <select className="entity-select" value={editEntityData.countryid || ''} onChange={e => {
                                                    const val = e.target.value;
                                                    const opt = countries.find(c => String(c.Id || c.id || c.Code || '') === val);
                                                    const cName = opt ? (opt.Text || opt.Name || opt.name || '') : '';
                                                    const matched = countryList.find(c => c.name.toLowerCase() === cName.toLowerCase());
                                                    if (matched) setSelectedCountries(prev => ({ ...prev, Mobile: matched }));
                                                    setEditEntityData({ ...editEntityData, countryid: val, stateid: '', cityid: '' });
                                                    fetchStates(val);
                                                }}>
                                                    <option value="">Select Country</option>
                                                    {countries.map((opt, idx) => {
                                                        const val = typeof opt === 'object' ? (opt.Id || opt.id || opt.Code || opt.SrcmedCampID || '') : opt;
                                                        const text = typeof opt === 'object' ? (opt.Text || opt.name || opt.Name || opt.Value || '') : opt;
                                                        return <option key={idx} value={val}>{text}</option>;
                                                    })}
                                                </select>
                                            </div>
                                            {renderField("State", "stateid", "select", states)}
                                            {renderField("City", "cityid", "select", cities)}
                                        </div>
                                    </div>

                                    <div className="entity-section">
                                        <div className="entity-section-title">Address & Other Details</div>
                                        <div className="entity-grid-2">
                                            <div className="entity-field-group">
                                                <label>Residential Address</label>
                                                <textarea className="entity-textarea" rows="2" value={editEntityData.residentialaddress || ''} onChange={e => setEditEntityData({ ...editEntityData, residentialaddress: e.target.value })} />
                                            </div>
                                            <div className="entity-field-group">
                                                <label>Official Address</label>
                                                <textarea className="entity-textarea" rows="2" value={editEntityData.officialaddress || editEntityData.officeaddress || ''} onChange={e => setEditEntityData({ ...editEntityData, officialaddress: e.target.value })} />
                                            </div>
                                        </div>
                                        <div className="entity-grid-3">
                                            {renderField("Pincode", "pincode")}
                                            {renderField("Source *", "Source", "select", sources)}
                                            {renderField("Medium", "Medium", "select", mediums)}
                                        </div>
                                        <div className="entity-grid-2">
                                            {renderField("Campaign", "Campaign", "select", campaigns)}
                                            <div className="entity-field-group">
                                                <label>Lead Tags</label>
                                                <div className="entity-tags-container">
                                                    <div className="entity-tags-input-box">
                                                        <input 
                                                            type="text" 
                                                            className="entity-tags-input-field" 
                                                            placeholder="Type tag and press enter" 
                                                            value={tagInput}
                                                            onChange={(e) => setTagInput(e.target.value)}
                                                            onKeyDown={handleAddTag}
                                                        />
                                                    </div>
                                                    <div className="entity-tags-list">
                                                        {editEntityData.Tags ? editEntityData.Tags.split(',').map((tag, idx) => {
                                                            const tagName = tag.trim();
                                                            if (!tagName) return null;
                                                            return (
                                                                <span key={idx} className="entity-tag-chip">
                                                                    {tagName}
                                                                    <span className="entity-tag-remove-icon" onClick={() => handleRemoveTag(tagName)}>×</span>
                                                                </span>
                                                            );
                                                        }) : <span className="entity-no-tags-msg">No tags added</span>}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="entity-field-group">
                                            <label>Initial Remarks</label>
                                            <textarea className="entity-textarea" rows="2" value={editEntityData.remarks || editEntityData.Remarks || ''} onChange={e => setEditEntityData({ ...editEntityData, remarks: e.target.value })} />
                                        </div>
                                    </div>

                                    <div className="entity-section">
                                        <div className="entity-section-title">Additional Fields</div>
                                        <div className="entity-grid-3">
                                            {renderField("Amount", "amount")}
                                            {renderField("Service", "Service")}
                                            {renderField("Charges", "Charges")}
                                        </div>
                                        <div className="entity-grid-3">
                                            {renderField("Bank Name okl", "Bank_Name_okl")}
                                            {renderField("Bill Amount", "Bill_Amount")}
                                            {renderField("Due Date", "Due_Date", "date")}
                                        </div>
                                        <div className="entity-grid-3">
                                            {renderField("Card Status", "Card_Status")}
                                            {renderField("Card Type", "Card_Type")}
                                            {renderField("Bank Name okl 2", "Bank_Name_okl_2")}
                                        </div>
                                        <div className="entity-grid-3">
                                            {renderField("Bill Amount 2", "Bill_Amount_2")}
                                            {renderField("Due Date 2", "Due_Date_2", "date")}
                                            {renderField("Card Status 2", "Card_Status_2")}
                                        </div>
                                        <div className="entity-grid-3">
                                            {renderField("Card Type 2", "Card_Type_2")}
                                            {renderField("Bank Name okl 3", "Bank_Name_okl_3")}
                                            {renderField("Bill Amount 3", "Bill_Amount_3")}
                                        </div>
                                        <div className="entity-grid-3">
                                            {renderField("Due Date 3", "Due_Date_3", "date")}
                                            {renderField("Card Status 3", "Card_Status_3")}
                                            {renderField("Card Type 3", "Card_Type_3")}
                                        </div>
                                        <div className="entity-grid-3">
                                            {renderField("Client ID", "ClientID")}
                                            {renderField("DOB", "DOB", "date")}
                                            {renderField("NAME", "NAME")}
                                        </div>
                                        <div className="entity-grid-3">
                                            {renderField("Study Level", "StudyLevel", "select", ["Diploma", "Graduate", "Post Graduate"])}
                                            {renderField("Course", "Course", "select", courseOptions)}
                                            {renderField("Centre For Education", "Centre_For_Education", "select", ["Delhi", "Jaipur", "Kota", "Lucknow"])}
                                        </div>
                                        <div className="entity-grid-3">
                                            {renderField("whatsaap_response", "whatsaap_response")}
                                            {renderField("Response", "Response")}
                                            {renderField("User Code", "User_Code")}
                                        </div>
                                        <div className="entity-grid-3">
                                            {renderField("Company Incorporation Date", "Company_Incorporation_Date", "date")}
                                            {renderField("MCA Registered City", "MCA_Registered_City")}
                                            {renderField("Equity Percentage", "Equity_Percentage")}
                                        </div>
                                        <div className="entity-grid-3">
                                            {renderField("Mandate Start Date", "Mandate_Start_Date", "date")}
                                            {renderField("Mandate End Date", "Mandate_End_Date", "date")}
                                            {renderField("OPE Preapproval", "OPE_Preapproval")}
                                        </div>
                                        <div className="entity-grid-3">
                                            {renderField("Business Referral Mandate", "Business_Referral_Mandate")}
                                            {renderField("Addendum", "Addendum")}
                                            {renderField("Project Name", "Project_Name")}
                                        </div>
                                        <div className="entity-grid-3">
                                            <div className="entity-field-group">
                                                <label>is Adult</label>
                                                <div className="entity-radio-group">
                                                    <label><input type="radio" name="is_Adult" value="yes" checked={editEntityData?.is_Adult === 'yes'} onChange={e => setEditEntityData({ ...editEntityData, is_Adult: e.target.value })} /> yes</label>
                                                    <label><input type="radio" name="is_Adult" value="no" checked={editEntityData?.is_Adult === 'no'} onChange={e => setEditEntityData({ ...editEntityData, is_Adult: e.target.value })} /> no</label>
                                                    <label><input type="radio" name="is_Adult" value="don't wish to answer" checked={editEntityData?.is_Adult === "don't wish to answer"} onChange={e => setEditEntityData({ ...editEntityData, is_Adult: e.target.value })} /> don't wish to answer</label>
                                                </div>
                                            </div>
                                            {renderField("Locate Our Office", "Locate_Our_Office")}
                                            {renderField("Test121", "test121")}
                                        </div>
                                        <div className="entity-field-group" style={{ gridColumn: '1 / -1' }}>
                                            <label>Number of users</label>
                                            <input type="text" className="entity-input full-width" value={editEntityData?.number_of_users || ''} onChange={e => setEditEntityData({ ...editEntityData, number_of_users: e.target.value })} />
                                        </div>
                                        <div className="entity-grid-3">
                                            {renderField("rrtr", "rrtr")}
                                            {renderField("dytdutdtjg", "dytdutdtjg")}
                                            {renderField("pending_amount", "pending_amount")}
                                        </div>
                                        <div className="entity-grid-3">
                                            {renderField("warranty valid till", "warranty_valid_till", "date")}
                                            {renderField("warranty start date", "warranty_start_date", "date")}
                                            {renderField("product", "product")}
                                        </div>
                                        <div className="entity-grid-3">
                                            {renderField("Select Option", "Select_Option")}
                                            {renderField("DATE TIME", "DATE_TIME", "date")}
                                            {renderField("Monthly EMI", "monthly_EMI")}
                                        </div>
                                        <div className="entity-grid-3">
                                            {renderField("Demo date", "Demo_date", "date")}
                                            {renderField("New test", "new_test")}
                                            {renderField("Trest", "trest")}
                                        </div>
                                        <div className="entity-grid-3">
                                            {renderField("Testing09099", "testing09099")}
                                            {renderField("Upload doc", "upload_doc")}
                                            {renderField("Official address", "official_address")}
                                        </div>
                                        <div className="entity-grid-3">
                                            {renderField("Test", "test")}
                                            {renderField("KW Requirement", "KW_Requirement")}
                                            <div className="entity-field-group">
                                                <label>Gender _</label>
                                                <div className="entity-radio-group">
                                                    <label><input type="radio" name="gender" value="Male" checked={editEntityData?.gender === 'Male'} onChange={e => setEditEntityData({ ...editEntityData, gender: e.target.value })} /> Male</label>
                                                    <label><input type="radio" name="gender" value="Female" checked={editEntityData?.gender === 'Female'} onChange={e => setEditEntityData({ ...editEntityData, gender: e.target.value })} /> Female</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>

                        {currentOperationMode !== 'none' && (
                            <div className="entity-operations-area">
                                <div className="op-content">
                                    <OperationsForms mode={currentOperationMode} task={editingEntity} onBack={() => setCurrentOperationMode('none')}
                                        onSuccess={() => { fetchEntityDetails(); setCurrentOperationMode('none'); }} />
                                </div>
                            </div>
                        )}

                        <div className="entity-action-sidebar">
                            {[
                                { mode: 'followup', icon: PhoneCall, title: 'Add Follow-up' },
                                { mode: 'mail', icon: Mail, title: 'Send Mail' },
                                { mode: 'sms', icon: MessageSquare, title: 'Send SMS' },
                                { mode: 'voice', icon: Mic, title: 'Send Voice' },
                                { mode: 'upload', icon: Upload, title: 'Upload' },
                                { mode: 'task', icon: ClipboardCheck, title: 'Add Task' },
                                { mode: 'appointment', icon: Calendar, title: 'Add Appointment' },
                                { mode: 'deal', icon: Percent, title: 'Add Deal' },
                                { mode: 'notes', icon: FileEdit, title: 'Add Notes' },
                                { mode: 'fill-webform', icon: FileText, title: 'Fill Webform' }
                            ].map((item) => (
                                <button key={item.mode} className={`sidebar-action-btn ${currentOperationMode === item.mode ? 'active' : ''}`}
                                    onClick={() => setCurrentOperationMode(item.mode)} title={item.title}>
                                    <item.icon size={18} />
                                </button>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EntityEdit;
